import { GovernmentIdCoverage } from 'dashboard/models/government-id-coverage';
import Action from 'lib/interfaces/Action';

export type GovernmentIdCoverageActions = Action<
  GovernmentIdCoverageActionType.SetGovernmentIdCoverage,
  SetGovernmentIdCoveragePayload
>;

export enum GovernmentIdCoverageActionType {
  SetGovernmentIdCoverage = 'SET_GOVERNMENT_ID_COVERAGE',
}

interface SetGovernmentIdCoveragePayload {
  governmentIdCoverage: GovernmentIdCoverage;
}

export function setGovernmentIdCoverage(
  governmentIdCoverage: GovernmentIdCoverage,
): Action<GovernmentIdCoverageActionType.SetGovernmentIdCoverage, SetGovernmentIdCoveragePayload> {
  return {
    payload: {
      governmentIdCoverage,
    },
    type: GovernmentIdCoverageActionType.SetGovernmentIdCoverage,
  };
}
